export default __webpack_public_path__ + "static/media/depositMethod.a5891707.svg";